import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import Text from '../../atoms/Text';
import RadioField from '../../molecules/RadioField';
import TextGroup from '../../molecules/TextGroup';
import ClassCardsList from '../../organisms/ClassCardsList';

import styles from './CreateCourseScheduleBlock.module.scss';
import usePresenter from './CreateCourseScheduleBlock.presenter';
import getProps from './CreateCourseScheduleBlock.props';
import { CreateCourseScheduleBlockCombinedProps } from './types';
import GenericModal from '../../organisms/GenericModal';

const CreateCourseScheduleBlock: React.FC<CreateCourseScheduleBlockCombinedProps> = (props) => {
  const {
    className,
    classes,
    stepperText,
    textGroup,
    radioField,
    classCardsList,
    button,
    backButton,
    createCourseButton,
    deleteClassModal,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.createCourseScheduleBlock;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.topContent, classes?.topContent)}>
        <Text
          className={cx(styles.stepperText, classes?.stepperText)}
          {...internalProps.stepperText}
          {...stepperText}/>
        <TextGroup
          className={cx(styles.textGroup, classes?.textGroup)}
          {...internalProps.textGroup}
          {...textGroup}/>
      </div>
      <div className={cx(styles.middleContent, classes?.middleContent)}>
        <RadioField
          className={cx(styles.radioField, classes?.radioField)}
          {...internalProps.radioField}
          {...radioField}/>
      </div>
      <ClassCardsList
        className={cx(styles.classCardsList, classes?.classCardsList)}
        {...internalProps.classCardsList}
        {...classCardsList}/>
      <Button
        className={cx(styles.button, classes?.button)}
        {...internalProps.button}
        {...button}/>
      <div className={cx(styles.bottomContent, classes?.bottomContent)}>
        <Button
          className={cx(styles.backButton, classes?.backButton)}
          {...internalProps.backButton}
          {...backButton}/>
        <Button
          className={cx(styles.createCourseButton, classes?.createCourseButton)}
          {...internalProps.createCourseButton}
          {...createCourseButton}/>
      </div>
      <GenericModal
        className={styles.modalWrapper}
        {...deleteClassModal} />
    </div>
  );
};

export default CreateCourseScheduleBlock;

